export default "__VITE_ASSET__d3517e1e__"